export const undoHotkeyCombos = 'ctrl+z, command+z'
export const undoHotkeyShortcutText = 'cmd + z'

export const redoHotkeyCombos = 'ctrl+y, command+y, shift+ctrl+z, shift+command+z'
export const redoHotkeyShortcutText = 'cmd + shift + z'

// TODO: default, but could be overriden per app
export const MAX_PDF_FILE_SIZE = 25 * 1024 * 1024; // 25MB in bytes
